import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@sendgrid/ui-components/tooltip';
import Styles from './g2gProfileExp.module.scss';

export const ProfileTooltip = ({ content }) => (
  <Tooltip
    content={content}
    direction="right"
    className={`${'has-underline'} ${Styles['profile-tooltip']}`}
    length="large"
  >
    <span>Why do we ask for this</span>
  </Tooltip>
);

ProfileTooltip.propTypes = {
  content: PropTypes.string.isRequired,
};

export default ProfileTooltip;
